<div class="p-4">
  <div class="rounded-lg p-1">
    <!-- Company First Card with side margins -->
    <div class="company-first-card mb-4 shadow-lg rounded-lg w-100 px-3 py-2 position-relative" :class="{
    'bolide-bg': hostname.includes('bolide.complyon'),
    'ndabeni-bg': hostname.includes('ndabenitrust.complyon'),
    'x-verdict-bg': hostname.includes('x-verdict'),
    'complyon-bg': hostname.includes('aicampus.complyon') ,
    'probaworkflows-bg': hostname.includes('probaworkflows'),
    'trustfirst-bg':hostname.includes('trustfirst.probaanalytics'),
    'rematholdings-bg':hostname.includes('rematholdings.complyon'),
    'dwypd-bg':hostname.includes('monitoring.dwypd.gov.za')
     }">
      <section class="hero-section w-100 px-2 py-1 d-flex justify-content-between align-items-start">

        <!-- Hero content on left -->
        <div class="hero-content p-1 me-5 col-md-7 col-lg-6">
          <p class="hero-title text-white text-xl fw-bold mt-4">
            All Your Applications, In One Place
          </p>
          <p class="hero-description mt-1 text-white text-x">
            Stay on top of submissions and next steps.
          </p>
        </div>

      </section>

      <div class="d-flex gap-2 justify-content-md-end mt-5">
        <!-- buttons -->
      </div>
    </div>

            <div>
              <p class="fw-semibold mb-2 text-white text-x">
                Applications Submitted
              </p>
              <p class="fw-bold  mb-0 text-white text-xl">
                {{ stats?.submitted || 0 }}
              </p>
            </div>

            <!-- Icon -->
            <i class="bi bi-send fs-2 text-white opacity-75"></i>

          </div>
        </div>
      
    

    <!-- HAS DATA -->
    <div v-if="table_safe_application_list.length">

      <!-- TABLE (Desktop) -->
      <div class="d-none d-md-block glassy-bg rounded-lg p-3 table-responsive text-xs">

        <table class="table table-hover" id="entity_form_management_table">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Application No</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Name</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Capacity</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="row in table_safe_application_list" :key="row['Application No']">
              <td class="text-xxs">{{ row['Application No'] }}</td>
              <td class="text-xxs">{{ row['Entity Type Name'] }}</td>
              <td class="text-xxs">{{ row['Date Created'] }}</td>
              <td class="text-xxs">{{ row['Status'] }}</td>
              <td>
                <button
                  class="btn btn-primary-dark btn-sm rounded-small shadow text-dark ms-1 text-xxs"
                  @click="view_entity_application_overview(
                    row['Application No'],
                    row['Status'],
                    row._entity_profile_id,
                    row._entity_type_id,
                    row._entity_name
                  )"
                >
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- MOBILE CARDS -->
      <div class="d-block d-md-none">

        <div
          v-for="row in table_safe_application_list"
          :key="row['Application No']"
          class="card mb-3 shadow-sm rounded-lg p-3"
        >

          <div class="d-flex justify-content-between align-items-start mb-2">
            <div>
              <p class="fw-bold text-xs mb-1">
                {{ row['Entity Type Name'] }}
              </p>

              <p class="text-dark text-xs mb-1">
                Reference : <span class="fw-semibold">{{ row['Application No'] }}</span>
              </p>

              <p class="text-dark text-xs mb-1">
                Date Created : <span class="fw-semibold">{{ row['Date Created'] }}</span> 
              </p>

              <p class="text-xs mb-0">
                Status : <span class="fw-semibold">{{ row['Status'] }}</span>
              </p>
            </div>
          </div>

          <!-- Actions -->
          <div class="d-flex justify-content-end gap-2 mt-2">

            <button
              class="btn-primary-dark btn-sm rounded-small shadow text-dark text-xxs"
              @click="view_entity_application_overview(
                row['Application No'],
                row['Status'],
                row._entity_profile_id,
                row._entity_type_id,
                row._entity_name
              )"
            >
              View
            </button>

            <button class="btn-primary-dark btn-sm rounded-small text-xxs">
              Withdraw
            </button>

          </div>

        </div>

      </div>

    </div>

    <!-- EMPTY STATE -->
    <div v-else class="text-center py-5 glassy-bg rounded-lg mt-3">

      <i class="bi bi-briefcase fs-1 text-muted mb-3 d-block"></i>

      <p class="fw-bold text-x mb-1">
        You have not applied for any jobs yet
      </p>

      <p class="text-dark text-xs mb-4">
        Browse available opportunities and apply to get started.
      </p>

      <button
        class="btn-primary-dark btn-sm rounded-small shadow text-dark text-xxs"
        @click="redirect_to_view_jobs_advertised"
      >
        <i class="bi bi-search me-1"></i>
        View Jobs & Apply
      </button>
    </div>

      <!-- Footer -->
      <AICampusFooter/>
    
